<template>
  <div class="text-center mt-5">
    <h2>Something went wrong</h2>
    <p class="text-muted">Please try again later.</p>
    <router-link to="/home" class="btn btn-success">Go Home</router-link>
  </div>
</template>
